import React, { Component } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import "./style.scss";
import { createPortal } from "react-dom";

/** Entered-state styles (was Transition "entered"). Avoids react-transition-group + React 18 nested-update loops. */
const ENTERED_CONTAINER = {
	transition: "all .2s ease .0s",
	opacity: 1,
	visibility: "visible"
};

const ENTERED_MODAL = {
	transition: "all .2s ease .1s",
	opacity: 1,
	visibility: "visible",
	transform: "translateY(0)"
};

class Modal extends Component {
	static propTypes = {
		size: PropTypes.oneOf([
			1200,
			1000,
			800,
			700,
			600,
			550,
			500,
			450,
			400,
			350,
			300,
			860,
			420
		]),
		closeIcon: PropTypes.bool,
		isOpen: PropTypes.bool,
		toggle: PropTypes.func,
		backdrop: PropTypes.oneOfType([
			PropTypes.bool,
			PropTypes.oneOf(["static"])
		]),
		scroll: PropTypes.bool
	};

	static defaultProps = {
		size: 500,
		closeIcon: true,
		isOpen: false,
		backdrop: true,
		scroll: false
	};

	_toggleAction = () => {
		this.props.toggle();
	};

	render() {
		const { size, closeIcon, isOpen, backdrop, scroll, className } = this.props;

		if (!isOpen) {
			return null;
		}

		const classNames = cx("mx-modal-wrapper", size && `max-w-${size}`);

		const classNames2 = cx(
			"mx-modal-box",
			className,
			scroll && "overflow-scroll"
		);

		return createPortal(
			<div className="mx-main-modal-container" style={ENTERED_CONTAINER}>
				<div className="mx-main-modal">
					<div
						className="mx-main-modal-overlay"
						onClick={() =>
							backdrop === true ? this._toggleAction() : undefined
						}
						style={ENTERED_CONTAINER}
					>
						{" "}
					</div>
					<div className={classNames} style={ENTERED_MODAL}>
						{closeIcon && (
							<div className="close-btn" onClick={this._toggleAction}>
								{" "}
							</div>
						)}
						<div className={classNames2}>{this.props.children}</div>
					</div>
				</div>
			</div>,
			document.body
		);
	}
}

export default Modal;
